/* NUVRA — coș premium (pagina /cart + coșul lateral din secțiunile nuvra-*).
 * O singură sursă de adevăr: /cart.js. Reguli livrare: easybox 19,99 lei, acasă 29,99 lei; gratuit de la 299 lei.
 * Recomandările vin doar din produse publicate, disponibile, din API-ul Shopify (recommendations + colecții). */
(function () {
  'use strict';
  var FREE = 29900, SHIP_LOCKER = 1999, SHIP_HOME = 2999, MAX_RECS = 4;
  /* formularul EasySell (html.nvx-es): un singur buton de comandă, pus de EasySell în [data-nvx-es-slot]; fără drum spre checkout-ul Shopify */
  function esForm() { return document.documentElement.classList.contains('nvx-es'); }
  var SLOT = '<span class="nvx-es-slot" data-nvx-es-slot></span>';
  var POOLS = ['huse-de-pat', 'paturi', 'lenjerii-de-pat', 'pilote'];
  var state = { cart: null, pool: null, related: {}, recs: [], busy: false, err: '' };
  var mounts = [];

  function money(c) { return ((Number(c) || 0) / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function sized(url, w) { if (!url) return ''; if (url.indexOf('//') === 0) url = 'https:' + url; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function cents(p) { return typeof p === 'number' ? p : Math.round(parseFloat(p || 0) * 100); }
  function kind(t) {
    t = String(t || '').toLowerCase();
    if (t.indexOf('husă') > -1 || t.indexOf('husa') > -1) return 'husa';
    if (t.indexOf('pătur') > -1 || t.indexOf('patur') > -1) return 'patura';
    if (t.indexOf('pilot') > -1) return 'pilota';
    return 'lenjerie';
  }
  function units(c) { return c.items.reduce(function (n, i) { return n + i.quantity; }, 0); }

  /* ---------- livrare și beneficii (verificate matematic) ---------- */
  function shippingFor(total, mode) { return total >= FREE ? 0 : (mode === 'acasa' ? SHIP_HOME : SHIP_LOCKER); }
  /* Comparație cu două comenzi separate: există o împărțire a coșului în două comenzi nevide
   * în care ambele ar plăti transport (ambele < 299 lei)? Dacă nu, în care doar una plătește?
   * Pe prețurile efective pe bucată (după reducerile de linie). */
  function twoOrdersShipping(c, mode) {
    var fee = mode === 'acasa' ? SHIP_HOME : SHIP_LOCKER;
    var list = [];
    c.items.forEach(function (i) { for (var k = 0; k < Math.min(i.quantity, 40); k++) list.push(i.final_price); });
    var n = list.length, T = list.reduce(function (a, b) { return a + b; }, 0);
    if (n < 2) return null;
    var sums = { 0: 1 };
    list.forEach(function (p) { Object.keys(sums).map(Number).forEach(function (s) { sums[s + p] = 1; }); });
    var both = false, one = false;
    Object.keys(sums).map(Number).forEach(function (s) {
      if (s <= 0 || s >= T) return;
      var a = s < FREE, b = (T - s) < FREE;
      if (a && b) both = true; else if (a || b) one = true;
    });
    if (both) return 2 * fee;
    if (one) return fee;
    return 0;
  }
  function benefits(c) {
    var T = c.total_price, mode = (c.attributes || {})['Metoda livrare NUVRA'] || '', now = shippingFor(T, mode), two = twoOrdersShipping(c, mode);
    var saving = two == null ? 0 : Math.max(0, two - now);
    return { total: T, ship: now, mode: mode, missing: Math.max(0, FREE - T), two: two, saving: saving, units: units(c) };
  }

  /* ---------- recomandări ---------- */
  function normalize(p, src) {
    var vs = (p.variants || []).filter(function (v) { return v.available; });
    if (!vs.length || p.available === false) return null;
    var v = vs[0], img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    if (typeof img === 'object' && img) img = img.src || '';
    return { id: p.id, title: p.title, handle: p.handle, type: kind(p.product_type || p.type), url: '/products/' + p.handle, image: img, variant: v.id, price: cents(v.price), src: src };
  }
  async function loadPool() {
    if (state.pool) return state.pool;
    try {
      var cached = JSON.parse(sessionStorage.getItem('nvx-pool-v1') || 'null');
      if (cached && Date.now() - cached.t < 15 * 60 * 1000) return (state.pool = cached.items);
    } catch (e) {}
    var res = await Promise.all(POOLS.map(function (h) {
      return fetch('/collections/' + h + '/products.json?limit=40').then(function (r) { return r.ok ? r.json() : { products: [] }; }).catch(function () { return { products: [] }; });
    }));
    var items = [];
    res.forEach(function (r) { (r.products || []).forEach(function (p) { var n = normalize(p, 'pool'); if (n) items.push(n); }); });
    state.pool = items;
    try { sessionStorage.setItem('nvx-pool-v1', JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
    return items;
  }
  async function loadRelated(pid) {
    if (state.related[pid]) return state.related[pid];
    var out = [];
    try {
      var r = await fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related');
      if (r.ok) (await r.json()).products.forEach(function (p) { var n = normalize(p, 'related'); if (n) out.push(n); });
    } catch (e) {}
    return (state.related[pid] = out);
  }
  async function computeRecs(c) {
    if (!c || !c.item_count) return [];
    var inCart = {}, cartKinds = {}, cartTitles = {};
    c.items.forEach(function (i) { inCart[i.product_id] = 1; cartKinds[kind(i.product_type)] = 1; cartTitles[i.product_title] = 1; });
    var pids = Object.keys(inCart).slice(0, 3);
    var lists = await Promise.all([loadPool()].concat(pids.map(loadRelated)));
    var seen = {}, cand = [];
    lists.slice(1).forEach(function (l) { l.forEach(function (p) { if (!seen[p.id]) { seen[p.id] = 1; cand.push(p); } }); });
    lists[0].forEach(function (p) { if (!seen[p.id]) { seen[p.id] = 1; cand.push(p); } });
    var M = Math.max(0, FREE - c.total_price);
    /* fără produse deja în coș și fără alt model cu același titlu (clienta l-ar vedea ca duplicat) */
    cand = cand.filter(function (p) { return !inCart[p.id] && !cartTitles[p.title] && p.price > 0 && p.variant; });
    cand.forEach(function (p) {
      var s = 0;
      if (M > 0) {
        if (p.price >= M) s = 100 - Math.min(40, (p.price - M) / M * 25); /* depășește pragul cu cheltuială minimă */
        else s = 45 * p.price / M;                                        /* apropie de prag */
      } else s = 50 - Math.min(30, p.price / 1000);                        /* prag atins: produse accesibile */
      if (p.src === 'related') s += 12;                                    /* compatibil (semnal Shopify) */
      if (!cartKinds[p.type]) s += 10;                                     /* complementar ca tip */
      p.score = s;
    });
    cand.sort(function (a, b) { return b.score - a.score; });
    var pick = [], perKind = {};
    cand.forEach(function (p) {
      if (pick.length >= MAX_RECS) return;
      if ((perKind[p.type] || 0) >= (cartKinds[p.type] ? 1 : 2)) return; /* varietate: tipurile deja din coș, max. 1 */
      if (pick.some(function (q) { return q.title === p.title; })) return; /* varietate: nu două modele cu același titlu */
      pick.push(p); perKind[p.type] = (perKind[p.type] || 0) + 1;
    });
    return pick;
  }

  /* ---------- API coș ---------- */
  async function fetchCart() { var r = await fetch('/cart.js', { credentials: 'same-origin' }); return r.json(); }
  async function post(url, body) {
    var r = await fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    var j = await r.json().catch(function () { return {}; });
    if (!r.ok) throw new Error(j.description || j.message || 'Coșul nu a putut fi actualizat. Încearcă din nou.');
    return j;
  }
  async function act(fn) {
    if (state.busy) return;
    state.busy = true; state.err = ''; paint();
    try { await fn(); state.cart = await fetchCart(); }
    catch (e) { state.err = e.message; }
    state.busy = false; paint(); refreshRecs();
  }
  function setQty(key, q) { return act(function () { return post('/cart/change.js', { id: key, quantity: Math.max(0, q) }); }); }
  function addVariant(id) { return act(function () { return post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }); }); }
  async function refreshRecs() { try { state.recs = await computeRecs(state.cart); } catch (e) { state.recs = []; } paint(); }

  /* ---------- randare ---------- */
  var ICON = {
    truck: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6.5h10.5v8.5H3zM13.5 9.5h4l3 3v2.5h-7"/><circle cx="7" cy="17" r="1.7"/><circle cx="17" cy="17" r="1.7"/></svg>',
    gift: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3.5" y="8.5" width="17" height="4" rx="1"/><path d="M5 12.5v8h14v-8M12 8.5v12M12 8.5S10.5 4 8 4.5 7 8.5 12 8.5zM12 8.5S13.5 4 16 4.5s1 4-4 4z"/></svg>',
    check: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12.5l4 4 8-9"/></svg>',
    coins: '<svg viewBox="0 0 24 24" aria-hidden="true"><ellipse cx="10" cy="6.5" rx="6" ry="2.5"/><path d="M4 6.5v4c0 1.4 2.7 2.5 6 2.5s6-1.1 6-2.5v-4M4 10.5v4c0 1.4 2.7 2.5 6 2.5M16 13c2.2.3 4 1.2 4 2.3v3.2c0 1.4-2.7 2.5-6 2.5s-6-1.1-6-2.5"/></svg>',
    trash: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 7h15M9.5 7V4.5h5V7M6.5 7l1 13h9l1-13M10.5 10.5v6M13.5 10.5v6"/></svg>',
    cart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l1.7 9.1a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 2-1.5L20 7H7"/><circle cx="9.5" cy="19" r="1.25"/><circle cx="17.5" cy="19" r="1.25"/></svg>',
    shield: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7.5 3v5.5c0 4.6-3.2 8.3-7.5 9.5-4.3-1.2-7.5-4.9-7.5-9.5V6z"/><path d="M8.5 12l2.5 2.5 4.5-5"/></svg>',
    help: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 14v-2.5a7.5 7.5 0 0 1 15 0V14"/><rect x="3.5" y="13" width="3.5" height="5.5" rx="1.5"/><rect x="17" y="13" width="3.5" height="5.5" rx="1.5"/><path d="M19 18.5c0 1.5-1.5 2.5-4 2.5h-2"/></svg>',
    heart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.3 4.3 4.3 0 0 1 19.5 10c0 5.4-7.5 10-7.5 10z"/></svg>',
    bag: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5.5 8h13l-1 12h-11z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M13 7l5 5-5 5"/></svg>'
  };
  function lineHTML(i, compact) {
    var variant = i.variant_title && i.variant_title !== 'Default Title' ? '<p class="ncx-line__var">' + esc(i.variant_title) + '</p>' : '';
    var w = compact ? 160 : 420;
    return '<li class="ncx-line">' +
      '<a class="ncx-line__img" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(sized(i.image, w)) + '" alt="' + esc(i.product_title) + '" width="' + w + '" height="' + w + '" loading="lazy">' : '') + '</a>' +
      '<div class="ncx-line__info"><a class="ncx-line__title" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' + variant +
      '<p class="ncx-line__price">' + money(i.final_price) + (i.quantity > 1 ? ' <span>× ' + i.quantity + ' = ' + money(i.final_line_price) + '</span>' : '') + '</p>' +
      '<div class="ncx-line__ctrl"><div class="ncx-qty" role="group" aria-label="Cantitate ' + esc(i.product_title) + '">' +
      '<button type="button" data-ncx-dec="' + esc(i.key) + '" data-q="' + i.quantity + '" aria-label="Scade cantitatea"' + (i.quantity <= 1 ? ' disabled' : '') + '>−</button>' +
      '<output aria-live="polite">' + i.quantity + '</output>' +
      '<button type="button" data-ncx-inc="' + esc(i.key) + '" data-q="' + i.quantity + '" aria-label="Crește cantitatea">+</button></div>' +
      '<button type="button" class="ncx-remove" data-ncx-rm="' + esc(i.key) + '" aria-label="Elimină ' + esc(i.product_title) + ' din coș">' + ICON.trash + '<span>Elimină</span></button></div></div></li>';
  }
  function progressHTML(b) {
    var pct = Math.min(100, Math.round(b.total / FREE * 100));
    var msg = b.missing > 0
      ? 'Îți mai lipsesc <strong>' + money(b.missing) + '</strong> pentru transport GRATUIT!'
      : '<strong>Felicitări! Ai deblocat transportul GRATUIT!</strong>';
    return '<div class="ncx-progress' + (b.missing ? '' : ' is-done') + '" aria-live="polite">' +
      '<div class="ncx-progress__head"><span class="ncx-ico">' + ICON.truck + '</span><p>' + msg + '</p><span class="ncx-progress__rule">Transport gratuit de la 299 lei</span></div>' +
      '<div class="ncx-bar" role="progressbar" aria-valuemin="0" aria-valuemax="299" aria-valuenow="' + Math.min(299, Math.floor(b.total / 100)) + '" aria-label="Progres către transport gratuit"><i style="width:' + pct + '%"></i></div>' +
      '<div class="ncx-progress__foot"><span><b>' + money(b.total) + '</b> / 299 lei</span><span>' + pct + '%</span></div></div>';
  }
  function recsHTML(b, compact) {
    if (!state.recs.length) return '';
    var cards = state.recs.map(function (p) {
      var after = b.total + p.price, unlocks = b.missing > 0 && after >= FREE;
      var w = compact ? 300 : 520;
      return '<li class="ncx-rec">' +
        '<a class="ncx-rec__img" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(sized(p.image, w)) + '" alt="' + esc(p.title) + '" width="' + w + '" height="' + w + '" loading="lazy">' : '') + '</a>' +
        '<div class="ncx-rec__body"><a class="ncx-rec__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a><p class="ncx-rec__price">' + money(p.price) + '</p>' +
        (unlocks ? '<p class="ncx-rec__free">' + ICON.truck + '<span>Cu acest produs beneficiezi de transport gratuit</span></p>' : (b.missing > 0 ? '<p class="ncx-rec__after">' + ICON.truck + '<span>Ajungi la ' + money(after) + '</span></p>' : '')) +
        '<button type="button" class="ncx-btn ncx-btn--add" data-ncx-add="' + p.variant + '">' + ICON.cart + '<span>Adaugă în coș</span></button></div></li>';
    }).join('');
    return '<section class="ncx-recs"><h2>Recomandate pentru tine</h2><ul class="ncx-recs__grid">' + cards + '</ul></section>';
  }
  function benefitsHTML(b) {
    var rows = '', fee = b.mode === 'acasa' ? SHIP_HOME : SHIP_LOCKER;
    var label = b.mode === 'acasa' ? 'Livrare la domiciliu' : (b.mode === 'easybox' ? 'Ridicare easybox' : 'Transport de la');
    rows += '<li class="ncx-ben"><span class="ncx-ico">' + ICON.truck + '</span><div><p><b>' + label + '</b><em>' + (b.ship ? money(b.ship) : 'GRATUIT') + '</em></p><small>' + (b.ship ? 'Easybox 19,99 lei sau acasă 29,99 lei; alegi livrarea în formularul de comandă.' : 'Ai atins pragul de 299 lei.') + '</small></div></li>';
    rows += '<li class="ncx-ben ncx-ben--green"><span class="ncx-ico">' + ICON.gift + '</span><div><p><b>' + (b.missing ? 'La pragul de 299 lei: transport GRATUIT' : 'Ai transport GRATUIT') + '</b></p><small>' + (b.missing ? 'Îți mai lipsesc ' + money(b.missing) + '.' : 'Ai atins pragul de 299 lei.') + '</small></div></li>';
    if (b.saving > 0) {
      var why = b.two === 2 * fee
        ? 'față de două comenzi separate, fiecare cu transport plătit (2 × ' + money(fee) + ').'
        : 'față de două comenzi separate, dintre care una ar fi plătit transport (' + money(fee) + ').';
      rows += '<li class="ncx-ben ncx-ben--save"><span class="ncx-ico">' + ICON.coins + '</span><div><p><b>Economisești ' + money(b.saving) + ' la transport</b></p><small>' + why + ' Nu este o reducere la prețul produselor.</small></div></li>';
    }
    return '<section class="ncx-benefits"><h2><span class="ncx-ico">' + ICON.gift + '</span>Beneficiile comenzii tale</h2><ul>' + rows + '</ul>' +
      (b.saving > 0 ? '<div class="ncx-saving"><span>Economie la transport:</span><strong>' + money(b.saving).replace(',00', '') + '</strong></div>' : '') + '</section>';
  }
  function summaryHTML(c, b, page) {
    var disc = c.total_discount > 0 ? '<div class="ncx-row"><span>Reduceri</span><b class="is-green">−' + money(c.total_discount) + '</b></div>' : '';
    var total = b.total + b.ship;
    return '<section class="ncx-summary"><h2>Sumar comandă</h2>' +
      '<div class="ncx-row"><span>Subtotal produse (' + b.units + ')</span><b>' + money(c.items_subtotal_price) + '</b></div>' + disc +
      '<div class="ncx-row"><span>' + (b.mode === 'acasa' ? 'Livrare acasă' : (b.mode === 'easybox' ? 'Livrare easybox' : 'Transport de la')) + '</span><b' + (b.ship ? '' : ' class="is-green"') + '>' + (b.ship ? money(b.ship) : 'GRATUIT') + '</b></div>' +
      (b.ship ? '<div class="ncx-row ncx-row--hint"><span>De la 299 lei</span><b class="is-green">GRATUIT</b></div>' : '') +
      '<div class="ncx-row ncx-row--total"><span>' + (b.mode || !b.ship ? 'Total estimat' : 'Total estimat de la') + '</span><strong>' + money(total) + '</strong></div>' +
      '<p class="ncx-note">Easybox: 19,99 lei; livrare la domiciliu: 29,99 lei. Gratuit de la 299 lei.</p>' +
      (page ? (esForm() ? '<div class="ncx-desk nvx-es-desk">' + SLOT + '</div>' : '<button type="submit" form="ncx-checkout" class="ncx-btn ncx-btn--main ncx-desk">Continuă comanda ' + ICON.arrow + '</button>') : '') + '</section>';
  }
  function trustHTML() {
    var wa = (document.querySelector('a[href*="wa.me"],a[href*="whatsapp"]') || {}).href || '/pages/contact';
    return '<section class="ncx-trust"><div class="ncx-tile"><span class="ncx-ico">' + ICON.shield + '</span><div><b>Plată securizată</b><small>Datele tale sunt în siguranță. Plată ramburs la livrare.</small></div></div>' +
      '<a class="ncx-tile ncx-tile--link" href="' + esc(wa) + '"><span class="ncx-ico">' + ICON.help + '</span><div><b>Ai nevoie de ajutor?</b><small>Contactează-ne, suntem aici pentru tine.</small></div><span class="ncx-chev">›</span></a></section>';
  }
  function whyHTML(b) {
    if (!b.missing) return '';
    return '<section class="ncx-why"><h2>De ce să adaugi încă un produs?</h2><ul>' +
      '<li><span class="ncx-ico">' + ICON.gift + '</span><div><b>Atingi pragul de 299 lei</b><small>și primești transport gratuit.</small></div></li>' +
      '<li><span class="ncx-ico">' + ICON.heart + '</span><div><b>Un somn mai confortabil</b><small>cu produse care se potrivesc perfect.</small></div></li>' +
      '<li><span class="ncx-ico">' + ICON.bag + '</span><div><b>Alegi tot ce ai nevoie</b><small>într-o singură comandă.</small></div></li></ul></section>';
  }
  function bannerHTML(el) {
    var img = el.getAttribute('data-banner');
    return '<section class="ncx-banner">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="900" height="900">' : '') +
      '<div><h2>Mai mult confort în casa ta</h2><p>Descoperă colecția noastră completă de lenjerii, pături și accesorii pentru un somn de neuitat.</p><a class="ncx-btn ncx-btn--main" href="/collections/all">Vezi toate produsele ' + ICON.arrow + '</a></div></section>';
  }

  function renderPage(el) {
    var c = state.cart;
    var busy = state.busy ? ' is-busy' : '', err = state.err ? '<p class="ncx-err" role="alert">' + esc(state.err) + '</p>' : '';
    if (!c) return;
    if (!c.item_count) {
      el.innerHTML = '<div class="ncx-wrap"><h1 class="ncx-h1">Coșul tău</h1><div class="ncx-empty"><p>Coșul tău este gol.</p><a class="ncx-btn ncx-btn--main" href="/collections/all">Descoperă colecția ' + ICON.arrow + '</a></div></div>';
      document.body.classList.remove('ncx-has-sticky');
      return;
    }
    var b = benefits(c), total = b.total + b.ship;
    el.innerHTML = '<div class="ncx-wrap' + busy + '">' +
      '<nav class="ncx-crumbs ncx-desk" aria-label="Navigare"><a href="/">Acasă</a><span>›</span><span>Coșul tău</span></nav>' +
      '<h1 class="ncx-h1">Coșul tău</h1><p class="ncx-lead"><span class="ncx-mob">' + b.units + (b.units === 1 ? ' produs' : ' produse') + ' în coș</span><span class="ncx-desk">Verifică produsele, apoi comandă cu plata la livrare.</span></p>' + err +
      '<div class="ncx-layout">' +
      '<div class="ncx-main ncx-card"><ul class="ncx-lines">' + c.items.map(function (i) { return lineHTML(i, false); }).join('') + '</ul>' + progressHTML(b) + '</div>' +
      '<div class="ncx-area-recs">' + recsHTML(b, false) + '</div>' +
      '<div class="ncx-area-why ncx-mob">' + whyHTML(b) + '</div>' +
      '<div class="ncx-area-ben">' + benefitsHTML(b) + '</div>' +
      '<div class="ncx-area-sum">' + summaryHTML(c, b, true) + '</div>' +
      '<div class="ncx-area-trust">' + trustHTML() + '</div>' +
      '<div class="ncx-area-banner ncx-mob">' + bannerHTML(el) + '</div>' +
      '</div></div>' +
      (esForm() ? '' : '<form id="ncx-checkout" action="/cart" method="post" hidden><input type="hidden" name="checkout" value="1"></form>') +
      '<div class="ncx-sticky">' + (esForm() ? SLOT : '<button type="submit" form="ncx-checkout" class="ncx-btn ncx-btn--main">Finalizează comanda' + (b.mode || !b.ship ? ' · ' + money(total) : '') + ' ' + ICON.arrow + '</button>') + '</div>';
    document.body.classList.add('ncx-has-sticky');
  }
  function renderDrawer(el) {
    var c = state.cart;
    if (!c) { el.innerHTML = '<div class="ncx-dr__head"><span>Coșul tău</span><button type="button" id="nvClose" data-ncx-close aria-label="Închide">×</button></div><div class="ncx-dr__body"><p class="ncx-sub">Se încarcă…</p></div>'; return; }
    var head = '<div class="ncx-dr__head"><span>Coșul tău' + (c.item_count ? ' (' + c.item_count + ')' : '') + '</span><button type="button" id="nvClose" data-ncx-close aria-label="Închide coșul">×</button></div>';
    if (!c.item_count) {
      el.innerHTML = head + '<div class="ncx-dr__body"><div class="ncx-empty"><p>Coșul tău este gol.</p><a class="ncx-btn ncx-btn--main" href="/collections/all">Descoperă colecția</a></div></div>';
      return;
    }
    var b = benefits(c), total = b.total + b.ship;
    var save = b.saving > 0 ? '<p class="ncx-dr__save">' + ICON.coins + '<span>Economisești ' + money(b.saving) + ' la transport față de două comenzi separate.</span></p>' : '';
    el.innerHTML = head + '<div class="ncx-dr__body' + (state.busy ? ' is-busy' : '') + '">' + (state.err ? '<p class="ncx-err" role="alert">' + esc(state.err) + '</p>' : '') +
      '<ul class="ncx-lines ncx-lines--compact">' + c.items.map(function (i) { return lineHTML(i, true); }).join('') + '</ul>' +
      progressHTML(b) + recsHTML(b, true) + save +
      '<div class="ncx-dr__sum"><div class="ncx-row"><span>Subtotal produse (' + b.units + ')</span><b>' + money(c.items_subtotal_price) + '</b></div>' +
      (c.total_discount > 0 ? '<div class="ncx-row"><span>Reduceri</span><b class="is-green">−' + money(c.total_discount) + '</b></div>' : '') +
      '<div class="ncx-row"><span>' + (b.mode === 'acasa' ? 'Livrare acasă' : (b.mode === 'easybox' ? 'Livrare easybox' : 'Transport de la')) + '</span><b' + (b.ship ? '' : ' class="is-green"') + '>' + (b.ship ? money(b.ship) : 'GRATUIT') + '</b></div>' +
      '<div class="ncx-row ncx-row--total"><span>' + (b.mode || !b.ship ? 'Total estimat' : 'Total estimat de la') + '</span><strong>' + money(total) + '</strong></div></div></div>' +
      '<div class="ncx-dr__foot">' + (esForm() ? SLOT : '<form action="/cart" method="post"><button type="submit" name="checkout" value="1" class="ncx-btn ncx-btn--main">Finalizează comanda' + (b.mode || !b.ship ? ' · ' + money(total) : '') + ' ' + ICON.arrow + '</button></form>') + '<a class="ncx-dr__link" href="/cart">Vezi coșul complet</a></div>';
  }
  function paint() {
    mounts.forEach(function (m) { m.type === 'page' ? renderPage(m.el) : renderDrawer(m.el); });
    var n = state.cart ? state.cart.item_count : null;
    if (n != null) Array.prototype.forEach.call(document.querySelectorAll('[data-nv-count],#nvCount'), function (x) { x.textContent = n; });
  }

  /* ---------- evenimente ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-ncx-inc],[data-ncx-dec],[data-ncx-rm],[data-ncx-add],[data-ncx-close]');
    if (!t) return;
    if (t.hasAttribute('data-ncx-close')) { closeDrawer(); return; }
    e.preventDefault();
    if (state.busy) return;
    if (t.hasAttribute('data-ncx-inc')) setQty(t.getAttribute('data-ncx-inc'), Number(t.getAttribute('data-q')) + 1);
    else if (t.hasAttribute('data-ncx-dec')) setQty(t.getAttribute('data-ncx-dec'), Number(t.getAttribute('data-q')) - 1);
    else if (t.hasAttribute('data-ncx-rm')) setQty(t.getAttribute('data-ncx-rm'), 0);
    else if (t.hasAttribute('data-ncx-add')) addVariant(t.getAttribute('data-ncx-add'));
  });

  /* ---------- coșul lateral: preia sertarul existent din secțiunile nuvra-* ---------- */
  var dim = null;
  function closeDrawer() { if (dim) { dim.classList.remove('on'); document.documentElement.style.overflow = ''; } }
  async function openDrawer() {
    if (!dim) { location.href = '/cart'; return; }
    dim.classList.add('on'); document.documentElement.style.overflow = 'hidden';
    await sync();
  }
  async function sync() {
    try { state.cart = await fetchCart(); } catch (e) {}
    paint(); refreshRecs(); return state.cart;
  }
  function init() {
    var page = document.querySelector('[data-ncx-page]');
    if (page) {
      mounts.push({ type: 'page', el: page });
      try { state.cart = JSON.parse(page.querySelector('script[type="application/json"]').textContent); } catch (e) {}
    }
    dim = document.querySelector('.nv-dim');
    var drawer = dim && dim.querySelector('.nv-drawer');
    if (drawer && !page) {
      drawer.classList.add('ncx-dr'); drawer.innerHTML = '';
      mounts.push({ type: 'drawer', el: drawer });
      new MutationObserver(function () { if (dim.classList.contains('on')) sync(); }).observe(dim, { attributes: true, attributeFilter: ['class'] });
    }
    window.NuvraPageCart = { refresh: sync, open: openDrawer, close: closeDrawer, money: function (c) { return money(c); } };
    paint();
    if (page) { if (!state.cart) sync(); else refreshRecs(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
